import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './PurchaseHistoryPage.css';
import { usePurchaseHistory } from '../logic/PurchaseHistoryLogic';
import { getLoggedInUser } from '../logic/loginLogic';
import { auth } from '../firebase';
import { playSound } from '../utils/soundPlayer';
import { useTranslation } from 'react-i18next'; // ✅ Import

const PurchaseHistoryPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(); // ✅ i18n hook

  const userId = auth.currentUser?.uid;
  const { history, loading } = usePurchaseHistory(userId);

  useEffect(() => {
    const user = getLoggedInUser();
    if (!user) {
      navigate('/');
    }
  }, [navigate]);

  if (!userId) {
    return (
      <div className="history-container">
        <h2>{t('history.title')}</h2>
        <p>{t('history.description')}</p>
        <button
          className="history-back-button"
          onClick={() => {
            playSound('return');
            navigate('/shop');
          }}
        >
          ⬅ {t('history.back')}
        </button>
      </div>
    );
  }

  return (
    <div className="history-container">
      <h2>{t('history.title')}</h2>
      <button className="history-back-button" onClick={() => navigate('/shop')}>
        ⬅ {t('history.back')}
      </button>

      {loading ? (
        <p>{t('history.loading')}</p>
      ) : history.length === 0 ? (
        <p>{t('history.noPurchases')}</p>
      ) : (
        <div className="history-table">
          <div className="history-header">
            <span>{t('history.headers.quantity')}</span>
            <span>{t('history.headers.itemName')}</span>
            <span>{t('history.headers.description')}</span>
            <span>{t('history.headers.totalCost')}</span>
            <span>{t('history.headers.status')}</span>
          </div>
          {history.map((item, index) => (
            <div className="history-row" key={index}>
              <span>{item.quantity}</span>
              <span>{item.itemName}</span>
              <span>{item.description}</span>
              <span>{item.totalCost} DP</span>
              <span>{t(`history.status.${item.status || 'Pending'}`)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PurchaseHistoryPage;
